<template>
    <FilterBar @open-filters="openFilterModal" @open-sort-by="openSortByModal" @close-sort-by="closeSortByModal" />
    <div class="plp-container">
        <EspotContainer v-if="recordSetTotal > 0" espotId="espot-plp-top" />
        <EspotContainer v-if="recordSetTotal > 0" espotId="espot-plp-middle" />
        <div v-if="recordSetTotal == 0 && !isLoading" class="no-results-plp-container">
            <p>No result found.</p>
            <a class="reset-filter" @click="resetFilters">Click here to reset your filter</a>
        </div>
        <ProductTile v-for="(product, index) in products" :key="product.uniqueId" :product="product" :index="index"
            :isMobile="isMobile" :isLargeTile="(isMobile ? isLargeTileMobile(index) : isLargeTile(index))" :class="{
                'large-tile': isLargeTile(index),
                'large-tile-mobile': isLargeTileMobile(index)
            }" />
        <SkeletonTile v-if="isLoading" v-for="index in pageSize" :key="'skeleton-' + index" :class="{
            'large-tile': isLargeTile(index - 1),
            'large-tile-mobile': isLargeTileMobile(index - 1)
        }" />
    </div>
    <div class="load-more-wrapper" v-if="recordSetTotal - products.length > 0" :data-filter-url="filterurl()"
        :key="'load-more-' + currentPage">
        <button @click="loadMoreProducts" class="load-more-button" :disabled="isLoading"
            data-element-id="X_X_Tiles_LoadMore">
            MORE
        </button>
        <noscript v-if="showhiddenurl()">
            <a :href="hiddenurl()">{{hiddenurl()}}</a>
        </noscript>
    </div>

    <FilterModal v-if="isFilterModalOpen" @close="closeFilterModal" :facetList="facetList"
        :totalFilterResult="totalFilterResult" @apply-filters="applyFilters" @reset-filters="resetFilters" />
    <SortByModal v-if="isSortByModalOpen" :position="sortByModalPosition" :positionClone="sortByModalPositionClone"
        @apply-sort="applySort" @close-sort-by="closeSortByModal" />
</template>

<script>
import ProductTilesContainer from './ProductTilesContainer.ts';
export default {
    ...ProductTilesContainer,
};
</script>
<style lang="scss">
@import "./ProductTilesContainer.scss";
</style>